<!--
-->
<template>
  <page-container>
    

    <div class="krj-toolbar">
      <search-bar @search="search" @reset="resetForm">
        <el-form ref="searchForm" :inline="true" size="small" :model="searchForm">
          <el-form-item label="名称：" prop="name">
            <el-input v-model="searchForm.name" placeholder="请输入" clearable />
          </el-form-item>
        </el-form>
      </search-bar>
      <div class="krj-toolbar__actions">
        <el-button type="primary" size="mini" @click="handleAdd">新增</el-button>
</div>
    </div>

    <div class="krj-table-wrap">
      <el-table :data="dataList" style="width: 100%" height="100%" class="tableGrow"
>
        <el-table-column prop="assetType" label="类型" show-overflow-tooltip min-width="80" >
          <template slot-scope="scope">
            {{ scope.row.assetType ? scope.row.assetType.name : '' }}

          </template>
        </el-table-column>
        <el-table-column prop="name" label="名称" show-overflow-tooltip min-width="80" />
        <el-table-column prop="model" label="型号" show-overflow-tooltip min-width="80" />
        <el-table-column prop="unit" label="单位" show-overflow-tooltip min-width="40" />
        <el-table-column prop="option" label="操作" min-width="120" >
          <template slot-scope="scope"
>
            <el-button type="primary" size="mini" @click="handleDetail(scope.row)">查看</el-button>
            <!-- <el-button type="primary" size="mini" @click="handleUpdate(scope.row)">修改</el-button> -->
            <el-button type="primary" size="mini" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="krj-pager">
      <el-pagination
        background
        :current-page.sync="pageInfo.pageNum"
        :page-sizes="[10, 20, 30, 40]"
        :page-size.sync="pageInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <standard-dialog :title="dialogTitleMap[dialogType]" width="60%" :visible.sync="dialogFlag" @close="onDialogClose">
      <el-form :model="formData" ref="formData" label-width="120px" :rules="formRules">
        <el-row type="flex" align="middle">
          <el-col :span="12">
            <el-form-item label="名称：" prop="name"
>
              <el-input placeholder="请输入内容" v-model="formData.name"></el-input>
            </el-form-item>
            <el-form-item label="型号：" prop="model"
>
              <el-input placeholder="请输入内容" v-model="formData.model"></el-input>
            </el-form-item>
            <el-form-item label="单位：" prop="unit"
>
              <el-input placeholder="请输入内容" v-model="formData.unit"></el-input>
            </el-form-item>
            <el-form-item label="类型：" prop="assetType">
              <el-select v-model="formData.assetType" value-key="id" placeholder="请选择" clearable filterable style="width: 100%">
                <el-option
                  v-for="item in assetTypeList"
                  :key="item.id"
                  :label="item.disabled ? (item.name + '（废弃）') : item.name"
                  :value="item"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="附件：">
              <el-upload
                action="#"
                :file-list="picList"
                :auto-upload="false"
                :multiple="true"
                :on-change="onUploadChange"
                :on-remove="onUploadRemove"
                accept="*"
              >
                <el-button size="small" type="primary">选取文件</el-button>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <div v-if="dialogType > 1" class="dialog-footer" align="right">
          <el-button size="small" type="primary" @click="onDialogConfirm">保 存</el-button>
        </div>
      </template>
    </standard-dialog>
  </page-container>
</template>
<script>
import { mapGetters } from "vuex";
import array from "lodash/array";
import { parseTime,deepClone } from "../../utils/index";
export default {
  components: {},
  filters: {
    timeFilter(time) {
      let date = new Date(time);
      return parseTime(date, "{y}-{m}-{d}");
    },
  },
  data() {
    return {
      pageInfo: {
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      dataList: [],
      searchForm: {
        name: "",
      },

      dialogFlag: false,
      dialogType: 1,
      formData: {
        name: "",
        model:"",
        unit:"",
        assetType: null,
      },
      formRules: {
        name: [
          { required: true, message: "名称", trigger: "blur" },
        ],
        model: [
          { required: true, message: "型号", trigger: "blur" },
        ],
        unit: [
          { required: true, message: "单位", trigger: "blur" },
        ],
        assetType: [
          { required: true, message: "类型", trigger: "blur" },
        ],
      },
      picList: [],
    };
  },
  computed: {
    ...mapGetters(["dialogTitleMap", "assetTypeList"]),
  },
  created() {
    this.$store.dispatch('demo/getAssetType')
    this.getList();
  },
  methods: {
    paging(list, pageIndex, pageSize) {
      if (!list) return [];
      const skipList = array.drop(list, pageSize * (pageIndex - 1));
      const pageData = array.take(skipList, pageSize);
      return pageData;
    },
    handleSizeChange(size) {
      this.pageInfo.pageNum = 1;
      this.getList();
    },
    handleCurrentChange(index) {
      this.pageInfo.pageNum = index;
      this.getList();
    },
    search() {
      this.pageInfo.pageNum = 1;
      this.getList();
    },
    resetForm() {
      this.$refs.searchForm.resetFields();
      this.search();
    },
    getList() {
      var params = {
          page: this.pageInfo.pageNum,
          size: this.pageInfo.pageSize,
          likeName: this.searchForm.name
      }
      this.$http
        .get('/api/device', {params})
        .then(res => {
          if ( res.success ) {
            var page = res.data;
            this.dataList = page.content
            this.total = page.total
          }
        });
    },
    handleDetail(item) {
      this.$router.push({
        path: "/asset/device/detail",
        query: { id: item.id },
      });
    },

    handleDetailDialog(item) {
      this.dialogFlag = true;
      this.dialogType = 1;

      this.formData = deepClone(item);
    },    

    handleAdd() {
      this.$store.dispatch("demo/updateAssetType").then(() => {
        this.picList = [];
        this.dialogFlag = true;
        this.dialogType = 3;
      });
    },
  
    dialogFormAddConfirm() {
      this.$refs.formData.validate((valid) => {
        if (valid) {
          var formData = new FormData();
          formData.append("data", JSON.stringify(this.formData));
          for (var i = 0; i < this.picList.length; i++) {
            formData.append("files", this.picList[i].raw)
          }

          this.$http
            .post("/api/device/create", formData)
            .then((res) => {
              if (res.success) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getList();
                this.onDialogClose();
              } else {
                this.$message({
                  message: res.msg,
                  type: "error",
                });
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    handleUpdate(row) {
      this.dialogFlag = true;
      this.dialogType = 2;

      this.formData = deepClone(row);

      this.$set(this.formData, "id", row.id)
      this.$set(this.formData, "name", row.name)

    },
    dialogFormUpdateConfirm() {
      this.$refs.formData.validate((valid) => {
        if (valid) {
          this.$http
            .post("/api/device", this.formData)
            .then((res) => {
              if (res.success) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getList();
                this.onDialogClose();
              } else {
                this.$message({
                  message: res.msg,
                  type: "error",
                });
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    handleDelete(row) {
      this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$http
            .delete("/api/device/"+ row.id)
            .then((res) => {
              if (res.success) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getList();
              } else {
                this.$message({
                  message: res.msg,
                  type: "error",
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    onDialogClose() {
      this.$refs.formData.resetFields();
      this.picList = [];
      this.dialogFlag = false;
    },
    onDialogConfirm() {
      if(this.dialogType == 1) {

      } else if(this.dialogType == 2) {
        this.dialogFormUpdateConfirm()
      } else if(this.dialogType == 3) {
        this.dialogFormAddConfirm()
      }
    },
    onUploadChange(file, fileList) {
      this.picList = fileList;
    },
    onUploadRemove(file, fileList) {
      this.picList = fileList;
    },    
  },
};
</script>
<style lang="scss" scoped>
.btnsPanel {
  margin-bottom: 10px;
}
.previewBox {
  display: flex;
  & > div {
    height: 600px;
  }
  .previewBoxLeft {
    flex-grow: 1;
    padding: 20px;
    .previewBoxLeftTop {
      border-bottom: 1px solid #e5e5e5;
      padding: 0 0 20px 0;
      .previewBoxLeftTopTitle {
        font-size: 26px;
        font-weight: bold;
        line-height: 38px;
      }
      .previewBoxLeftTopNum {
        font-size: 18px;
        line-height: 38px;
      }
      .previewBoxLeftTopBtns {
        text-align: right;
        padding-right: 20px;
      }
    }
    .previewBoxLeftBom {
      padding: 20px 0 0 0;
    }
  }
  .previewBoxRight {
    flex-grow: 2;
    overflow: auto;
    .previewBoxRightHtml {
      width: 100%;
    }
  }
}
</style>
